import api from './api';

export const listarPreInscricoes = async (page = 1, limit = 10, searchTerm = '', statusFilter = '') => {
 try {
   const response = await api.get('/pre-inscricoes', {
     params: {
       page,
       limit,
       search: searchTerm,
       status: statusFilter,
     },
   });
   return response.data;
 } catch (error) {
   console.error('Erro ao listar pré-inscrições:', error.response?.data || error.message);
   throw error;
 }
};

export const listarPreInscricoesPorClasseOuCurso = async (id, tipo, page = 1, limit = 10) => {
 try {
   const response = await api.get(`/pre-inscricoes/por-classe-curso/${id}`, {
     params: {
       tipo,
       page,
       limit,
     },
   });
   return response.data;
 } catch (error) {
   console.error('Erro ao listar pré-inscrições por classe/curso:', error);
   throw error;
 }
};

export const obterPreInscricao = async (id) => {
 try {
   const response = await api.get(`/pre-inscricoes/${id}`);
   return response.data;
 } catch (error) {
   console.error('Erro ao obter pré-inscrição:', error);
   throw error;
 }
};

export const criarPreInscricao = async (preInscricaoData) => {
 try {
   console.log('Dados enviados para criar pré-inscrição:', preInscricaoData);
   const response = await api.post('/pre-inscricoes', preInscricaoData);
   if (!response || !response.data) {
     throw new Error('Resposta inválida do servidor ao criar pré-inscrição');
   }
   console.log('Pré-inscrição criada com sucesso:', response.data);
   return response.data;
 } catch (error) {
   console.error('Erro detalhado ao criar pré-inscrição:', error);
   if (error.response) {
     console.error('Detalhes do erro do servidor:', error.response.data);
   }
   throw error;
 }
};

export const atualizarPreInscricao = async (id, preInscricaoData) => {
 try {
   const response = await api.put(`/pre-inscricoes/${id}`, preInscricaoData);
   return response.data;
 } catch (error) {
   console.error('Erro ao atualizar pré-inscrição:', error);
   throw error;
 }
};

export const excluirPreInscricao = async (id) => {
 try {
   const response = await api.delete(`/pre-inscricoes/${id}`);
   return response.data;
 } catch (error) {
   console.error('Erro ao excluir pré-inscrição:', error);
   throw error;
 }
};

export const obterComprovativoPDF = async (id) => {
 try {
   console.log('Iniciando obterComprovativoPDF para id:', id);
   const response = await api.get(`/pre-inscricoes/${id}/comprovativo`, {
     responseType: 'blob'
   });
   console.log('PDF recebido com sucesso');
   return response.data;
 } catch (error) {
   console.error('Erro ao obter comprovativo PDF:', error);
   throw error;
 }
};

export const enviarMensagemPersonalizada = async (preInscricaoId, { assunto, mensagem }) => {
  try {
    console.log('Enviando mensagem personalizada para pré-inscrição:', preInscricaoId);
    const response = await api.post(
      `/pre-inscricoes/${preInscricaoId}/mensagem`, 
      { assunto, mensagem },
      { timeout: 30000 } // Configuração específica para esta operação
    );
    console.log('Mensagem enviada com sucesso');
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar mensagem personalizada:', error);
    throw error;
  }
};